<template>
  <div style="position: relative;" :style="mainStyle">
    <div class="taxiAc-page" :style="mainStyle">
      <img v-if="lang == 'zh'" src="../../images/banner_1_zh.png" class="w-f">
      <img v-else-if="lang == 'km'" src="../../images/banner_1_km.png" class="w-f">
      <img v-else src="../../images/banner_1_en.png" class="w-f">
      <span class="flex-xy-center taxiAc-page-title">{{ $root.getText('couponPack') }}</span>

      <span class="taxiAc-page-subtitle">
        <span>{{ $root.getText('value') }}</span>
        <strong>{{ couponPackValue }}</strong>
        <span>KHR</span>
      </span>

      <RuleDialog :data="ruleData"></RuleDialog>

      <div
        class="taxiAc-coupon-item"
        v-for="(item, $index) in couponList"
        :key="$index"
      >
        <div class="taxiAc-coupon-amount" v-if="isAmount(item)">
          <strong>{{ numFormat(item.couponAmt, item.currency) }}</strong>
          <span>{{ item.currency  }}</span>
        </div>
        <div class="taxiAc-coupon-amount" v-else>
          <strong>{{ item.preferRatio }}%</strong>
          <span>OFF</span>
          <div v-if="item.preferLimitUsd" class="taxiAc-coupon-preferLimit flex-icenter">{{ $root.getText('upTo', { value: moneyFormat(item.preferLimitUsd, item.currency) }) }}</div>
        </div>
        <div class="taxiAc-coupon-text">{{  item.couponTitle || 'Coupon' }}</div>
        <div class="taxiAc-coupon-count">X{{ item.couponCount }}</div>
      </div>

      <div class="taxiAc-page-btnPhl"></div>

    </div>
    <div
      v-if="isInit"
      class="taxiAc-page-footer"
      :class="{
        active: info.phoneNumber,
        disabled: status !== 11
      }"
      >
      <template v-if="status == 11">
        <div class="taxiAc-page-input flex-icenter">
          <div class="mr-8 flex-icenter" @click="showPixDialog">
            <img v-if="pix == '855'" src="../../images/b1.png" class="taxiAc-page-icon">
            <img v-else src="../../images/b2.png" class="taxiAc-page-icon">
            <span class="font-12">+{{ pix }}</span>
            <img src="../../images/arrow.png" class="w-16">
          </div>
          <input
            type="number"
            v-model="info.phoneNumber"
            :placeholder="$root.getText('phoneNumber')"
            @input="phoneNumberChange"
          >
        </div>
        <div class="taxiAc-page-input flex-icenter" v-if="info.phoneNumber">
          <input type="number" v-model="info.verificationCode" :placeholder="$root.getText('verificationCode')">
          <div
            @click="sendSms"
            class="verification-get flex-xy-center"
            :class="{ 'phoneDisabled': phoneDisabled }"
          >
            <span v-if="currentTimeoutNumber">{{ currentTimeoutNumber }}</span>
            <span v-else>{{ $root.getText('get') }}</span>
          </div>
        </div>
        <div
          @click="sendSmsLogin"
          class="taxiAc-page-btn flex-xy-center"
        >
          <van-loading v-if="loading" type="spinner" size="24px" />
          <span v-else>{{ $root.getText('claimYourCouponNow') }}</span>
        </div>
      </template>
      <div v-if="status == 10 || status == 12" class="taxiAc-page-btnDisabled flex-xy-center">{{ $root.getText('notStart') }}</div>
      <div v-else-if="status == 13"  class="taxiAc-page-btnDisabled flex-xy-center">{{ $root.getText('endAct') }}</div>
    </div>

    <transition name="fuckyou">
      <div class="pix-tk" v-if="showPix">
        <div class="pix-tk-item" @click="selectPix(855)">
          <img src="../../images/b1.png" class="pix-tk-logo">
          <span class="pix-tk-label">កម្ពុជា</span>
          <span class="pix-tk-pix">+855</span>
        </div>
        <div class="pix-tk-item" @click="selectPix(86)">
          <img src="../../images/b2.png" class="pix-tk-logo">
          <span class="pix-tk-label">中国</span>
          <span class="pix-tk-pix">+86</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getActivity, receiveCoupon, activityLimit } from "../../../apis/api";
import { sendLoginSms, smsLogin } from "$superAppUser/api/gateway-web/operator/login";
import { urlQueries } from '$common/utils/url/url'
import { getUserInfo, isAndroid, goAppPath, goAppHome, removeUserInfo } from '$common/utils/common/common'
import storage from '$common/utils/storage';
import RuleDialog from '../../components/ruleDialog.vue'
import { Loading } from 'vant'

Vue.use(Loading)
export default {
  documentTitle: {
    i18n: "home.documentTitle"
  },
  data() {
    return {
      couponPackValue: '80,000',
      loading: false,
      isInit: false,
      pix: '855',
      showPix: false,
      couponList: [],
      info: {
        phoneNumber: '',
        verificationCode: '',
      },
      currentTimeoutNumber: 0,
      ruleData: null,
      status: 11
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale
    },
    isWownowApp: () => {
      return navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
    },
    mainStyle() {
      if (this.$root.clientHeight) {
        return `height: ${this.$root.clientHeight}px;`
      }
      return ''
    },
    phoneDisabled() {
      if (this.pix == 855 && /^0[0-9]{8,10}$/.test(this.info.phoneNumber)) {
        return false
      }
      if (this.pix == 86 && /^1[0-9]{10}$/.test(this.info.phoneNumber)) {
        return false
      }
      return true
    },
  },
  mounted() {
    const queries = urlQueries()
    this.activityNo = queries["activityNo"] || queries["i"]
    setTimeout(() => {
      this.getActivityInfo()
    }, isAndroid ? 500 : 32)
  },
  methods: {
    getActivityInfo() {
      this.$root.showLoading()
      const startTime = Date.now();
      return new Promise(async (resolve, reject) => {
        if (!this.activityNo) {
          reject()
          return this.$root.toast('缺失相关活动参数')
        }
        getActivity({ activityNo: this.activityNo }).then(res => {
          if (res.rspCd == '00000') {
            const data = res.data
            this.couponList = this.getCouponList(data.couponList || [])
            this.status = data.status.code
            this.ruleData = {
              beginTime: data.beginTime,
              endTime: data.endTime,
              description: data.description
            }
          }
        }).finally(() => {
          this.$root.hideLoading()
          this.isInit = true
        })
      })
    },
    isAmount(item) {
      if (item.discountType && item.discountType.code === 10) {
        return true
      }
      return false
    },
    // 发送验证码
    sendSms() {
      if (this.phoneDisabled) return false
      if (this.sending || !this.info.phoneNumber) return false
      if (this.currentTimeoutNumber > 0) return false
      this.sending = true
      this.info.verificationCode = ''
      this.currentTimeoutNumber = 60
      this.startSmsTimeout()
      sendLoginSms({ mobile: `${this.pix}${this.info.phoneNumber}` }, {
        hideErrorMsg: () => true,
        success: (data, resState) => {},
        fail: (error) => {
          this.sending = false;
          error.rspInf && this.$root.toast(error.rspInf)
        }
      }
      ).finally((...args) => {
        this.sending = false;
      })
    },
    goToTargetData(list, msg) {
      storage.setItem(`taxiActivityCoupon_${this.activityNo}`, JSON.stringify({
        receivedCouponList: list,
        msg: msg,
        ruleData: this.ruleData
      }));
      this.$router.push({
        name: msg ? 'sorry' : 'gc',
        query: {
          activityNo: this.activityNo
        }
      })
    },
    onClickGet() {
      this.loading = true
      const channel = urlQueries()['channel'] || '124'
      this.$root.showLoading()
      const params = {
        channel,
        activityNo: this.activityNo,
        operatorNo: this.userInfo.operatorNo,
        loginName: this.userInfo.loginName,
      }
      console.log("body: ", params)
      receiveCoupon(params, {
        success: (res) => {
          console.log("🚀 ~ onClickGet ~ res:",  res)
          if (res.code == '00000') {
            if(res?.receivedCouponList?.length >0 ) {
                this.goToTargetData(this.couponList, '')
            }else {
                this.goToTargetData([], this.$root.getText('errorTip2'))
            }
          } else if (res.code === 'MKC4031') {
            this.goToTargetData([], this.$root.getText('errorTip3'))
          } else {
            this.goToTargetData([], res.msg)
          }
        },
        fail: (error) => {
          if (error && error.rspCd === 'MKC4031') {
            this.goToTargetData([], this.$root.getText('errorTip3'))
            return false
          }
          this.goToTargetData([], res.msg)
        }
      }, this.h5Login).finally(() => {
        this.loading = false
        this.$root.hideLoading()
      })
    },
    isActivityLimit() {
      return new Promise(async (resolve, reject) => {
        const res = await activityLimit(this.userInfo)
        const data = res.data || {}
        // 是否出行新用户
        if (data.goNowNewUser) {
          if (!data.receiveGoNowNewUserCoupon) {
            this.onClickGet()
            return false
          } else {
            this.goToTargetData([], this.$root.getText('errorTip2'))
          }
        } else {
          this.goToTargetData([], this.$root.getText('errorTip1'))
        }
        resolve()
      })
    },
    async sendSmsLogin() {
      if (!(this.info.verificationCode && this.info.phoneNumber)) {
        return this.$root.toast(this.$root.getText('completeForm'))
      }
      if (this.loading) return false
      let userInfo = null
      if (this.isWownowApp) {
        try {
          const userInfo = await getUserInfo(false)
          if (userInfo && userInfo.loginName) {
            this.userInfo = userInfo
            if (this.userInfo.operatorNo == `${this.pix}${this.info.phoneNumber}`) {
              return this.isActivityLimit()
            }
          }
        } catch (error) {
          console.error(error)
        }
      }
      this.loading = true
      const { channel, agreementNo } = urlQueries()
      const params = {
        mobile: `${this.pix}${this.info.phoneNumber}`,
        smsCode: this.info.verificationCode,
        agreementNo: agreementNo || "AG1139809824121798655",
        biz: "SMS_LOGIN",
        registerChannel: 124
      }
      if (channel) params.registerChannel = this.$route.query.channel
      console.log(`smsLogin`, params)
      smsLogin(params, {
        hideErrorMsg: () => true,
        success: async (data, state, res) => {
          this.userInfo = {
            operatorNo: data.operatorNo,
            loginName: data.loginName
          }
          this.h5Login = true
          this.$root.hideLoading()
          data.appNo = 21;
          storage.setItem("userInfo", data);
          storage.setItem("operatorNo", data.operatorNo);
          storage.setItem("loginName", data.loginName);
          storage.setItem("appNo", data.appNo);
          storage.setItem('accessToken', data.accessToken)
          if (data.oldUser == false) {
            // 是新用户
            this.onClickGet()
          } else {
            await this.isActivityLimit()
          }
          this.loading = false;
        },
        fail: res => {
          this.loading = false;
          this.$root.hideLoading()
          res.rspInf && this.$root.toast(res.rspInf)
        }
      })
    },
    startSmsTimeout() {
      this.currentTimeoutNumberTimer && clearTimeout(this.currentTimeoutNumberTimer)
      if (this.currentTimeoutNumber <= 0) {
        this.currentTimeoutNumber = ''
        return false
      }
      this.currentTimeoutNumberTimer = setTimeout(() => {
        this.currentTimeoutNumber -= 1
        this.startSmsTimeout()
      }, 1000)
    },
    phoneNumberChange() {
      const val = String(this.info.phoneNumber)
      if (this.pix == 855 && val && val.substring(0, 1) !== '0') {
        this.info.phoneNumber = `0${this.info.phoneNumber}`
      }
    },
    getCouponList(list) {
      const count = {}
      const ids = []
      list.forEach(item => {
        if (!count[item.couponNo]) {
          count[item.couponNo] = 0
          ids.push(item)
        }
        count[item.couponNo] += 1
      })
      ids.forEach(item => {
        item.couponCount = count[item.couponNo]
      })
      return ids
    },
    showPixDialog() {
      this.showPix = true
    },
    hidePixDialog() {
      this.showPix = false
    },
    selectPix(pix) {
      if (this.pix !== pix) {
        this.info.phoneNumber = ''
      }
      this.pix = pix
      this.hidePixDialog()
    },
    numFormat(val, unit) {
      if (unit == 'KHR') {
        return Math.floor(val)
      } else {
        return Number(val).toFixed(2)
      }
    },
    moneyFormat(val, unit) {
      if (unit == 'KHR') {
        return `៛${Math.floor(val)}`
      } else {
        return `$${Number(val).toFixed(2)}`
      }
    }
  },
  components: {
    RuleDialog
  }
};

</script>

<style lang="stylus" scoped>
.mr-4 {
  margin-right: 4px;
}

.mr-8{
  margin-right: 8px;
}

.flex-col{
  flex-direction: column;
}

.w-16{
  width: 16px;
}

.flex-icenter{
  display: flex;
  align-items: center;
}

.flex-xy-center{
  display: flex;
  align-items: center;
  justify-content: center;
}

.w-f{
  width: 100%;
}

.font-12{
  font-size: 12px;
}
.font-14{
  font-size: 14px;
}


.taxiAc-share-code{
  width: 100%;
}

.taxiAc-page{
  height: 100%;
  background-color: #BC2021;
  overflow-x: hidden;
  overflow-y: auto;

  .taxiAc-page-title{
    margin-bottom: 10px;
    height: 25px;
    font-weight: 600;
    font-size: 18px;
    color: #fff;
  }

  .taxiAc-page-subtitle{
    display: flex;
    align-items: baseline;
    justify-content: center;
    margin-bottom: 20px;
    height: 37px;
    font-size: 12px;
    color: #fff;
    span{
      display: block;
      margin: 0 4px;
      transform: translateY(-3px);
    }
    strong {
      font-weight: bold;
      font-size: 32px;
    }
  }
}

.taxiAc-coupon-item{
  position: relative;
  padding-left: 32px;
  margin: 0 auto 8px auto;
  width: 291px;
  height: 63px;
  background: url("https://img.tinhnow.com/wownow/files/pro/app/MEF/BF/BD/5441cf7dab3440258aa17cc54378a2d9.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;

  .taxiAc-coupon-amount{
    position: relative;
    margin-top: 12px;
    display: flex;
    align-items: baseline;
    height: 28px;
    strong {
      font-weight: bold;
      font-size: 24px;
      color: #FC2040;
    }
    span {
      display: block;
      margin: 0 3px;
      font-size: 11px;
      font-weight: bold;
      color: #FC2040;
    }
  }
  .taxiAc-coupon-text{
    line-height: 17px;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
  }
  .taxiAc-coupon-count{
    position: absolute;
    top: 22px;
    right: 18px;
    line-height: 20px;
    font-size: 14px;
    color: #333333;
    z-index: 10;
  }
}

.taxiAc-page-footer{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 161px;
  padding: 17px 20px;
  z-index: 10;
  background-color: rgba(61, 0, 0, 0.58);
  background: linear-gradient(rgba(151, 12, 13, 0.8), #970C0D);;
  border-top-left-radius: 19px;
  border-top-right-radius: 19px;
  transition: height .3s ease-in-out;
  &.active {
    height: 229px;
  }
  &.disabled{
    height: 106px !important;
  }
}


.taxiAc-page-btnDisabled{
  margin: 0 auto;
  width: 291px;
  height: 56px;
  background: #ECBEBF;
  border-radius: 32px;
  font-weight: 600;
  font-size: 16px;
  color: #970C0D;
}

.taxiAc-page-btnPhl{
  width: 100%;
  height: 255px;
}

.taxiAc-coupon-preferLimit{
  padding: 0 6px;
  height: 20px;
  background-color: #f9e2d4;
  font-size: 10px;
  color: #FC2040;
  border-radius: 10px;
  transform: translate(-10px, -16px);
}

.taxiAc-page-input{
  margin-bottom: 12px;
  padding-left: 28px;
  width: 335px;
  height: 56px;
  background: #fff;
  border-radius: 12px;
  &:active{
    opacity: 0.98;
  }
  input {
    width: 100%;
    height: 56px;
    font-size: 14px;
    color: #333;
    background-color: transparent;
  }

  .taxiAc-page-icon{
    display: block;
    margin-right: 4px;
    width: 32px;
  }

  .verification-get{
    position: relative;
    margin: 0 8px;
    width: 109px;
    height: 44px;
    background: #FFE8EB;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    color: #FC2040;
    flex-shrink: 0;
    overflow: hidden;
    &:active{
      filter: brightness(0.98);
    }
    &.phoneDisabled:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.7);
      z-index: 10;
    }
  }
}

.taxiAc-page-btn{
  position: absolute;
  bottom: 17px;
  left: 50%;
  width: 291px;
  height: 56px;
  background: #FFDB39;
  border-radius: 32px;
  font-weight: 600;
  font-size: 16px;
  color: #691818;
  transform: translateX(-50%);
  z-index: 10;
  transition: transform .3s;
  &:active{
    filter: brightness(0.9);
  }
}

.fuckyou-enter-active, .fuckyou-leave-active {
  transition: all .2s;
}
.fuckyou-enter, .fuckyou-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
.pix-tk{
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 54px 0;
  width: 100%;
  background-color: #fff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  z-index: 1000;
  .pix-tk-item{
    display: flex;
    align-items: center;
    padding: 0 15px;
    width: 100%;
    height: 54px;
    border-bottom: 1px solid #ebedf0;
  }
  .pix-tk-logo{
    height: 24px;
    flex-shrink: 0;
  }
  .pix-tk-label{
    width: 100%;
    padding-left: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #333;
  }
  .pix-tk-pix{
    font-size: 14px;
    font-weight: 400;
    color: #999;
    flex-shrink: 0;
  }
  .pix-tk-cannle{
    font-size: 14px;
    font-weight: 400;
    color: #999;
    flex-shrink: 0;
  }
}
</style>
